import { Box, BoxProps } from "@mui/material";
import React, { PropsWithChildren } from "react";

interface IProps extends PropsWithChildren {
  sx?: BoxProps["sx"];
}

export const MultiLineCell = ({
  sx,
  children,
}: IProps): React.ReactElement<IProps> => {
  return (
    <Box
      sx={{
        whiteSpace: "normal",
        lineHeight: 1.25,
        py: 0.5,
        display: "flex",
        alignItems: "center",
        height: "100%",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
